/*
 * Pixelgipfel Collection Filters
 * Progressive enhancement over a native GET <form> that renders Shopify
 * Search & Discovery facets (collection.filters). Works without JS:
 * every facet has an "Anwenden" submit button and the sort is a submit-on-
 * change select. JS adds: instant apply on desktop, a mobile filter drawer
 * (batch then "Anzeigen"), outside-click close, and per-facet value search.
 */
(function () {
  var form = document.querySelector('[data-pg-filterbar]');
  if (!form) return;

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var facets = form.querySelector('[data-pg-facets]');
  var openBtn = form.querySelector('[data-pg-filter-open]');
  var drawerOpen = false;

  /* ---- mobile drawer ---- */
  function openDrawer() {
    drawerOpen = true;
    document.documentElement.classList.add('pg-filter-lock');
    if (facets) facets.classList.add('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawerOpen = false;
    document.documentElement.classList.remove('pg-filter-lock');
    if (facets) facets.classList.remove('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  form.querySelectorAll('[data-pg-filter-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpen) closeDrawer();
  });

  /* ---- keep URLs clean: drop empty params on submit ---- */
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[name]').forEach(function (inp) {
      if (inp.type !== 'checkbox' && inp.value.trim() === '') inp.disabled = true;
    });
  });

  /* ---- instant apply (desktop, or when drawer is closed) ---- */
  form.addEventListener('change', function (e) {
    var t = e.target;
    var isCheckbox = t.matches && t.matches('input[type="checkbox"]');
    var isSort = t.matches && t.matches('[data-pg-sort]');
    if (!isCheckbox && !isSort) return;
    if (mqMobile.matches && drawerOpen) return; // mobile: wait for "Anzeigen"
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  /* ---- price inputs: apply on Enter ---- */
  form.querySelectorAll('.pg-facet__price input').forEach(function (inp) {
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    });
  });

  /* ---- per-facet value search (only rendered when > 8 values) ---- */
  form.querySelectorAll('[data-pg-facet-search]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase();
      var panel = inp.closest('.pg-facet__panel');
      if (!panel) return;
      panel.querySelectorAll('.pg-facet__opt').forEach(function (opt) {
        var label = opt.getAttribute('data-pg-opt-label') || '';
        opt.style.display = label.indexOf(q) > -1 ? '' : 'none';
      });
    });
    // don't let a keystroke bubble to the form-level Enter handler twice
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
  });

  /* ---- close open desktop dropdowns on outside click ---- */
  document.addEventListener('click', function (e) {
    if (mqMobile.matches) return; // drawer mode manages itself
    form.querySelectorAll('details[data-pg-facet][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  /* ---- keep only one desktop dropdown open at a time ---- */
  form.querySelectorAll('details[data-pg-facet]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open || mqMobile.matches) return;
      form.querySelectorAll('details[data-pg-facet][open]').forEach(function (o) {
        if (o !== d) o.open = false;
      });
    });
  });

  /* ---- if viewport grows past mobile while drawer open, reset ---- */
  mqMobile.addEventListener('change', function (e) {
    if (!e.matches && drawerOpen) closeDrawer();
  });
})();
